export enum Locale {
    English = "en",
    Swedish = "sv",
    BrazilianPortuguese = "pt-BR",
}
